import React from 'react';
import styled from 'styled-components';

import Button from '../components/Button';
import { useStores } from '../stores';
import { sanitizeHTML } from '../utilities';
import useConfig from './useConfig';
import useMenuFunctions from './useMenuFunctions';

export default function useSubHeaderScopeRenderer() {
  const { button: buttonConfig } = useConfig();
  const { executeFunction } = useMenuFunctions();
  const { network } = useStores();

  return React.useCallback(
    item => {
      if (!item) {
        return null;
      }

      switch (item.type) {
        case 'button':
          return (
            <StyledButton
              key={item.position}
              color={buttonConfig.color}
              hoverColor={buttonConfig.hoverColor}
              fontFamily={buttonConfig.fontFamily}
              borderRadius={buttonConfig.borderRadius}
              onClick={() => executeFunction(item.functionName, item.functionArgs)}
              disabled={network.isOffline || network.isSlowConnection}
            >
              {item.label}
            </StyledButton>
          );
        case 'html':
          return (
            <HtmlContent
              key={item.position}
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(item.content) }}
            />
          );
        default:
          return null;
      }
    },
    [
      buttonConfig.borderRadius,
      buttonConfig.color,
      buttonConfig.fontFamily,
      buttonConfig.hoverColor,
      executeFunction,
      network.isOffline,
      network.isSlowConnection
    ]
  );
}

const StyledButton = styled(Button)`
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const HtmlContent = styled.div`
  font-size: 14px;
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
